import api from '../../api/api';
import { GetQuestionnaire, SendQuestionnaire } from './types';

class QuestionnaireService {
  static async getQuestionnaire(): Promise<GetQuestionnaire['return']> {
    try {
      const { data } = await api.get<GetQuestionnaire['api']>('/questionnaire');
      return data;
    } catch (err) {
      throw new Error('Failed to retrieve questionnaire');
    }
  }

  static async sendQuestionnaire(
    props: SendQuestionnaire['props'],
  ): Promise<boolean> {
    const { enterpriseWebUsername, answers } = props;
    const toApi: SendQuestionnaire['toApi'] = {
      userName: enterpriseWebUsername,
      answers,
    };
    await api.post('/questionnaire/answers', toApi);
    return true;
  }
}
export default QuestionnaireService;
